/* eslint-disable no-console */
/* eslint-disable no-undef */
export const ddoInit = (ddo) => {
  if (window._T && typeof (_T.sendPageDataToAnalytics) !== 'undefined') {
    _T.sendPageDataToAnalytics(ddo);
  } else {
    window._T = (window._T ? _T : {});
    _T.pageData = (window._T.pageData ? _T.pageData : []);
    _T.pageData.push(ddo || window.digitalData);
  }
};

export const ddoEventInit = (eventObj) => {
  if (window._T && typeof (_T.sendEventDataToAnalytics) !== 'undefined') {
    _T.sendEventDataToAnalytics(eventObj);
  } else {
    window._T = (window._T ? _T : {});
    _T.eventData = (window._T.eventData ? _T.eventData : []);
    _T.eventData.push(eventObj);
  }
};
